import { useState } from 'react';
import { toast } from '@cencosud-cencommerce/paris-uikit';

import { useRepository } from '@/Application/Providers/Repository';
import type { Address } from '@/modules/address/domain/Address';
import { updateAddress } from '@/modules/customer/application/updateAddress';
import { useCustomerContext } from '@/sections/customer/CustomerContext';
import { getPayloadForCustomerAddress } from '@/sections/customer/hooks/utils';
import { usePlaceData } from '@/sections/region/GooglePlaceDataContext';

const useUpdateCustomerAddress = () => {
  const { customerRepository } = useRepository();
  const { setData } = useCustomerContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { placeData } = usePlaceData();

  const trigger = async (address: Address) => {
    setIsLoading(true);
    try {
      const addressPayload = getPayloadForCustomerAddress(address, placeData);

      const updatedCustomer = await updateAddress(
        customerRepository,
        addressPayload
      );
      setData(updatedCustomer);
      toast({
        status: 'success',
        title: 'Los cambios se guardaron con éxito'
      });
    } catch (e) {
      toast({
        status: 'error',
        title: 'No pudimos editar tu dirección',
        body: 'Por favor, intenta de nuevo.'
      });
      setError((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return { trigger, isLoading, error };
};

export default useUpdateCustomerAddress;
